import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

export default function DisciplineCard({
  id,
  name,
  description,
  icon: Icon,
}) {

  return (
    <Box
      as={RouterLink}
      to={`/disciplines/${id}`}
      p={8}
      bg="white"
      borderRadius="2xl"
      boxShadow="0 4px 20px rgba(0,0,0,0.08)"
      _hover={{
        boxShadow: "0 12px 40px rgba(16, 185, 129, 0.2)",
        textDecoration: "none",
        transform: "translateY(-4px)",
      }}
      transition="all 0.3s"
      h="full"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <VStack align="start" spacing={4} w="full">
        {Icon && (
          <Box
            fontSize="3xl"
            color="#10B981"
            bg="#E2E8F0"
            p={4}
            borderRadius="lg"
          >
            <Icon />
          </Box>
        )}
        <VStack align="start" spacing={2} w="full">
          <Heading
            size="md"
            color="#1E293B"
            fontFamily="Merriweather, serif"
          >
            {name}
          </Heading>
          <Text
            fontSize="sm"
            color="#475569"
            lineHeight={1.6}
          >
            {description}
          </Text>
        </VStack>
      </VStack>

      <HStack
        color="#10B981"
        fontSize="sm"
        fontWeight="600"
        spacing={2}
        mt={4}
      >
        <Text>Learn More</Text>
        <Box>
          <FaArrowRight />
        </Box>
      </HStack>
    </Box>
  );
}
